import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ThumbnailComponent } from './thumbnail.component';
import { DotsDirectivesModule } from '@uzurv/dots';

@NgModule({
  imports: [CommonModule, DotsDirectivesModule, MatCardModule, MatButtonModule, MatIconModule],
  declarations: [ThumbnailComponent],
  exports: [ThumbnailComponent]
})
export class ThumbnailModule {}
